import './index.less';
import { DropDownProps, Dropdown } from 'antd';

interface props extends Partial<DropDownProps> {
  title?: React.ReactNode;
  children: React.ReactNode;
}
export const RevxDropdown = (props: props) => {
  const contentRender = (
    <>
      {props.title ? (
        <div className="revx-dropdown-text">{props.title}</div>
      ) : props.overlay ? (
        props.overlay
      ) : (
        <></>
      )}
    </>
  );
  return (
    <Dropdown {...props} className="revx-dropdown" overlay={contentRender}>
      {props.children}
    </Dropdown>
  );
};
